const assessmentTypes = {
  QUIZ: {
    type: "QUIZ",
    label: "Quiz",
  },
  WRITE_PROMPT: {
    type: "WRITE_PROMPT",
    label: "Write prompt",
  },
  POWER_WORDS_ACTIVITY: {
    type: "POWER_WORDS_ACTIVITY",
    label: "Power words",
  },
  GUIDED_HIGHLIGHTING_QUIZ: {
    type: "GUIDED_HIGHLIGHTING_QUIZ",
    label: "Guided Highlighting",
  },
  CHECKS_FOR_UNDERSTANDING_QUIZ: {
    type: "CHECKS_FOR_UNDERSTANDING_QUIZ",
    label: "Checks for understanding",
  },
};

export default assessmentTypes;
